module.exports = __webpack_public_path__ + "static/img/404.7beb901.svg";